import { getParsedEthersError } from '@enzoferey/ethers-error-parser';
import { Provider, TransactionRequest } from '@ethersproject/providers';

import { networkConfigs } from '../constants';
import { AppDispatch } from '../store';
import { setEstimateGasError } from '../store/state/swap/swapSlice';
import { calculateGasMargin } from '../utils';

export const estimateGas = async (
  tx: TransactionRequest,
  provider: Provider,
  chainId: number,
  dispatch?: AppDispatch
): Promise<string> => {
  try {
    if (dispatch) dispatch(setEstimateGasError(null));
    return calculateGasMargin(await provider.estimateGas(tx)).toString();
  } catch (e) {
    const parsedEthersError = getParsedEthersError(e); // return ReturnValue from @enzoferey/ethers-error-parser
    if (dispatch) dispatch(setEstimateGasError(parsedEthersError));
    return getDefaultGasLimit(chainId);
  }
};

export const getDefaultGasLimit = (chainId: number): string => {
  return networkConfigs[chainId].minGasLimit;
};
